import { h, Component } from 'preact';
import Store from 'store/store';

import { getData } from 'utils/dynamicData';
import { joinClasses } from 'utils/utils';
import { renderCookieConsentLink } from 'utils/cookies';
import { copy, a11yCopy, pageName } from 'utils/copy';
import { track } from 'utils/tracking';

import PageLink from 'components/pageLink/pageLink';
import ShareIcons from 'components/shareIcons/shareIcons';

import s from 'components/footer/footer.sss';

// Should this be based on build date or current date?
// Probably build date: https://stackoverflow.com/a/2391555/1336843
const copyrightDate = (typeof window !== 'undefined' ? new Date(window.__BUILD_DATE__) : new Date()).getFullYear();

export default class Footer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			links: [],
			legal: [],
			copyright: null,
		};

		this.onAnyClick = this.onAnyClick.bind(this);
		this.renderLink = this.renderLink.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const data = await getData('navigation');
			const links = (data?.footer?.links || []).map(section => (section || []).filter(Boolean)).filter(e => e?.length);
			const legal = (data?.footer?.legal || []).filter(Boolean);
			const rawCopyright = data?.footer?.copyright;
			const copyright = Array.isArray(rawCopyright)
				? rawCopyright.map(item => ({ ...item, name: item.name?.replace(/\[Year\]/gi, copyrightDate) }))
				: typeof rawCopyright === 'string'
					? [{ name: rawCopyright.replace(/\[Year\]/gi, copyrightDate), destination: '' }]
					: null;
			this.setState({ links, legal, copyright });
		} catch (err) {
			console.error(err);
		}
	}

	onAnyClick(e) {
		// close on internal navigation
		const link = e.target.closest('a');
		if (!link) return;

		let label = link.innerText || link.textContent || '';
		const isLegalLink = link.matches(`.${s.legal} a`);
		if (isLegalLink) {
			track('footer', 'footer_legal_click', label);
		} else {
			track('footer', 'footer_nav_click', label);
		}
	}

	renderLink(link) {
		if (typeof link === 'string') {
			link = { name: pageName(link), destination: link };
		}
		if (!link?.name) return;
		const destination = link.destination;

		if (!destination) return <span>{link.name}</span>;
		if (destination === 'cookies') return renderCookieConsentLink(link.name);

		const store = Store.get();
		const isUS = store?.client?.geo?.countryCode?.toLowerCase() === 'us';
		// Only show CA Notice link for US users
		// (NOTE: we should find a more consistent way to do this than looking for a specific string in the link, which could change)
		if (!isUS && destination.includes?.('california-consumer-privacy-act')) {
			return null;
		}

		if (/^https?:\/\//i.test(destination)) {
			return <a href={destination} target="_blank" rel="noopener noreferrer">{link.name}</a>;
		}
		return <PageLink to={destination}>{link.name}</PageLink>;
	}

	render(props, state) {
		return (
			<footer class={s.wrapper} onClickCapture={this.onAnyClick}>
				<div class={s.content}>
					<div class={s.main}>
						<div class={s.logo}>
							<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt={a11yCopy('$UNIVERSAL_ALT_TEXT')} />
						</div>
						<div class={s.linksWrapper}>
							{state.links.map(section => (
								<div class={joinClasses(s.section, s.links)}>
									{section.map(this.renderLink)}
								</div>
							))}
						</div>
						<div class={s.shareWrapper}>
							<ShareIcons class={s.share} type="footer" />
						</div>
					</div>
					<div class={s.legal}>
						{state.legal.map(this.renderLink)}
					</div>
					<div class={s.copyright}>
						{state.copyright ? state.copyright.map(this.renderLink) : copy('$FOOTER_COPYRIGHT', { year: copyrightDate })}
					</div>
				</div>
			</footer>
		);
	}

}